import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { SimpleListAdapter, TS_DropDown } from '@nu-art/thunderstorm-frontend/index';
import { metaPathwayAction_Type_LabelMap, MetaPathwayAction_Types } from '@app/pathway-shared';
import { DropDown_DefaultCaret } from '@app/styles/frontend/ui/consts';
const MetaPathwayAction_Type_MandatoryProps = {
    adapter: () => SimpleListAdapter([...MetaPathwayAction_Types], item => _jsx(_Fragment, { children: metaPathwayAction_Type_LabelMap[item.item] })),
    caret: DropDown_DefaultCaret,
    placeholder: 'Pick A Type'
};
export const Dropdown_MetaPathwayAction_Type = TS_DropDown.prepare(MetaPathwayAction_Type_MandatoryProps);
//# sourceMappingURL=ui-components.js.map